import "./ExportSurveyPage.scss";

import { Alert, Button, Flex, Text } from "@fluentui/react-northstar";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router";

import { useSurvey } from "../../_shared/actions/useSurvey";
import { PollyIcon } from "../../_shared/components/PollyIcon";
import { TeamsLoader } from "../../_shared/components/TeamsLoader";
import { isError } from "../../_shared/services/ChannelApi";
import { useTeamsContext } from "../../_shared/state/TeamsContextProvider";
import { isMobileClient } from "../../_shared/utils/clientHelper";
import { downloadSurveyCsv } from "../../_shared/utils/pollyResultsExport";

export const ExportSurveyPage: React.FC = () => {
  const { surveyId: surveyIdParam } = useParams<{ surveyId: string }>();
  const { teamsContext } = useTeamsContext();
  const { survey, surveyError, isSurveyLoading, loadSurvey } = useSurvey();
  const [showFileDownloaded, setShowDownloaded] = useState<React.ReactNode>();

  useEffect(() => {
    loadSurvey(teamsContext, decodeURIComponent(surveyIdParam));
  }, [loadSurvey, surveyIdParam, teamsContext]);

  if (surveyError) {
    return <Alert danger content={surveyError} />;
  }

  if (!survey || isSurveyLoading) {
    return <TeamsLoader isLoading loadingMessage="Loading..." />;
  }

  if (isMobileClient(teamsContext)) {
    return (
      <Alert
        warning
        content="Exports are not supported on mobile clients.  Please use the Microsoft Teams desktop or web client!"
      />
    );
  }

  return (
    <Flex column hAlign="center" gap="gap.large" className="export-survey-page">
      <Text content={survey?.title} size="large" weight="bold" align="center" />

      {!showFileDownloaded && (
        <Button
          icon={<PollyIcon icon="download-icon" inheritColor />}
          primary
          content="Download Export"
          onClick={async () => {
            const result = await downloadSurveyCsv(survey, teamsContext);

            if (isError(result)) {
              console.error(result);
              setShowDownloaded(<Alert danger content={"Error exporting: " + result.message} />);
              return;
            }

            if (teamsContext.app.host.clientType !== "web") {
              setShowDownloaded(
                <span>
                  The file was saved to the download folder on your computer as <pre>{result}</pre>
                </span>
              );
            }
          }}
        />
      )}

      {showFileDownloaded}
    </Flex>
  );
};
